<template>
  <div>
    <ul class="view-selectors">
      <Selector
        v-for="view in views"
        :key="view.name"
        :class="{ hideSaleShare: hideSaleShareView(view.name) }"
        :view="view"
        :isActiveView="isActiveView(view.name)"
        @setActiveViewName="$emit('setActiveViewName', view.name)"
      />
    </ul>
  </div>
</template>

<script>
import Selector from "./Selector";
import { mapGetters } from "vuex";

const STORE_ID = {
  acne: 54,
  by_melane_birger: 490,
  nudie_jeans: 133,
};

export default {
  components: {
    Selector,
  },
  props: {
    views: {
      type: Array,
      required: true,
    },
    activeViewName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      currentStore: "user/getCurrentStore",
    }),
  },
  methods: {
    isActiveView(viewName) {
      return this.activeViewName === viewName;
    },
    hideSaleShareView(name) {
      return name === "saleShare" && Object.values(STORE_ID).includes(this.currentStore.store_id);
    },
  },
};
</script>

<style lang="scss" scoped>
.view-selectors {
  display: flex;
  align-items: flex-start;
}
.hideSaleShare {
  display: none;
}
</style>
